import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/CadastrarServicosAtendidos.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { buscarServicosAtendidosByPontoMototaxi } from '../servicos/listagemServico';
import { cadastrarServicosAtendidos } from '../servicos/cadastroServico';
import { aplicarMascaraValor } from '../uteis/mascaras/mascaraValor';
import { FaMotorcycle, FaDollarSign, FaMoon, FaSun } from 'react-icons/fa';

const valoresIniciais = {
  servico_atendido_id: null,
  ponto_mototaxi_id: null,
  valor_6_as_23: '',
  valor_23_as_6: '',
  observacao: '',
};

function CadastrarServicosAtendidos() {
  const [listaServicos, setListaServicos] = useState([]);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const parseValorParaCentavos = (valorMascarado) => {
    if (!valorMascarado) return 0;
    const apenasNumeros = String(valorMascarado).replace(/\D/g, '');
    if (apenasNumeros === '') return 0;
    return parseInt(apenasNumeros, 10);
  };

  // Converte centavos (ex: 1234567) para string mascarada "12.345,67"
  const centavosParaMascarado = (centavos) => {
    if (centavos === null || centavos === undefined || centavos === '') return '';
    const n = parseInt(String(centavos).replace(/\D/g, ''), 10);
    if (isNaN(n)) return '';
    const reais = (n / 100).toFixed(2).replace('.', ',');
    return reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  // Normaliza valor que pode vir como "12345.67", "12345,67" ou number 12345.67 para máscara "12.345,67"
// Substituir a função valorRealParaMascarado existente por esta versão:
const valorRealParaMascarado = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '';

  const s = String(valor).trim();

  // Caso 1: já tem vírgula como separador decimal -> remover pontos (se houver) e trocar vírgula por ponto para parse
  if (s.indexOf(',') !== -1) {
    const semPontos = s.replace(/\./g, '');         // remove separadores de milhares (ex: "1.234,56" -> "1234,56")
    const normalizado = semPontos.replace(',', '.'); // "1234,56" -> "1234.56"
    const num = parseFloat(normalizado);
    if (isNaN(num)) return '';
    const reais = num.toFixed(2).replace('.', ',');
    return reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Caso 2: não tem vírgula. Pode ser "100.00" (ponto decimal) ou "100000" (valor em centavos sem formatação) ou "1.000" (mil)
  // Tentativa direta de parseFloat funciona para "100.00" -> 100
  const numDireto = parseFloat(s);
  if (!isNaN(numDireto)) {
    const reais = numDireto.toFixed(2).replace('.', ',');
    return reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Fallback: remover tudo que não é dígito e tratar como centavos (ex: "10000" -> 100,00)
  const apenasNumeros = s.replace(/\D/g, '');
    if (apenasNumeros === '') return '';
    const asNumber = parseInt(apenasNumeros, 10) / 100;
    const reais = asNumber.toFixed(2).replace('.', ',');
    return reais.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };


  useEffect(() => {
    console.log('Entrou no useEffect do CadastrarServicosAtendidos.js...');

    const cookies = Cookies.get();
    const dadosCookiesString = cookies.dadosCookies;

    if (dadosCookiesString) {
      try {
        const dadosCookies = JSON.parse(dadosCookiesString);
        const dadosPontoMototaxi = dadosCookies.dadosPontoMototaxi;
        const idPontoMototaxi = dadosPontoMototaxi.id;

        console.log('Dados cookies:', dadosCookies);
        console.log('Dados ponto mototaxi:', dadosPontoMototaxi);
        console.log('id ponto mototaxi:', idPontoMototaxi);

        (async () => {
          try {
            console.log('Buscando serviços atendidos pelo ponto...', idPontoMototaxi);
            const resposta = await buscarServicosAtendidosByPontoMototaxi(dadosCookies);
            console.log('Resposta buscarServicosAtendidosByPontoMototaxi:', resposta);

            const arrayServicosAtendidos = resposta.arrayServicosAtendidos;
            setListaServicos(arrayServicosAtendidos);
            console.log('listaServicos atualizada com dados da API.');

            // inicializa o formData com valores iniciais para cada serviço,
            // mas agora pré-carrega valores vindos da API (se existirem)
            const inicial = {};
            arrayServicosAtendidos.forEach(s => {
              // tenta extrair valor diurno / noturno em vários formatos
              let valorDiurnoMascarado = '';
              let valorNoturnoMascarado = '';

              // prioriza campos em centavos se existirem
              if (s.valor_6_as_23_centavos !== undefined && s.valor_6_as_23_centavos !== null) {
                valorDiurnoMascarado = centavosParaMascarado(s.valor_6_as_23_centavos);
              } else if (s.valor_6_as_23 !== undefined && s.valor_6_as_23 !== null) {
                valorDiurnoMascarado = valorRealParaMascarado(s.valor_6_as_23);
              }

              if (s.valor_23_as_6_centavos !== undefined && s.valor_23_as_6_centavos !== null) {
                valorNoturnoMascarado = centavosParaMascarado(s.valor_23_as_6_centavos);
              } else if (s.valor_23_as_6 !== undefined && s.valor_23_as_6 !== null) {
                valorNoturnoMascarado = valorRealParaMascarado(s.valor_23_as_6);
              }

              // mantemos logs sobre o que veio e o que foi formatado
              console.log(`Serviço ${s.id} - valores originais:`, {
                valor_6_as_23: s.valor_6_as_23,
                valor_6_as_23_centavos: s.valor_6_as_23_centavos,
                valor_23_as_6: s.valor_23_as_6,
                valor_23_as_6_centavos: s.valor_23_as_6_centavos
              });
              console.log(`Serviço ${s.id} - valores formatados:`, {
                valorDiurnoMascarado,
                valorNoturnoMascarado
              });

              inicial[s.id] = {
                servico_atendido_id: s.id,
                ponto_mototaxi_id: idPontoMototaxi,
                valor_6_as_23: valorDiurnoMascarado,
                valor_23_as_6: valorNoturnoMascarado,
                observacao: s.observacao || ''
              };
            });

            setFormData(inicial);
          } catch (err) {
            console.error('Erro ao buscar serviços atendidos:', err);
          }
        })();
      } catch (e) {
        console.error('Erro ao fazer parse dos dadosCookies:', e);
      }
    } else {
      console.warn('Cookie "dadosCookies" não encontrado');
    }
  }, []);

  const handleChange = (servicoId, campo, valor) => {
    let novoValor = valor;
    if (campo === 'valor_6_as_23' || campo === 'valor_23_as_6') {
      novoValor = aplicarMascaraValor(valor);
    }
    setFormData(prev => ({
      ...prev,
      [servicoId]: {
        ...prev[servicoId],
        [campo]: novoValor
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Enviando dados para cadastro (formData mascarado):', formData);

    try {
      const dadosArray = Object.values(formData).map(item => {
        const valorDiurnoCentavos = parseValorParaCentavos(item.valor_6_as_23);
        const valorNoturnoCentavos = parseValorParaCentavos(item.valor_23_as_6);

        console.log(`Servico ${item.servico_atendido_id} - diurno: "${item.valor_6_as_23}" -> ${valorDiurnoCentavos} centavos`);
        console.log(`Servico ${item.servico_atendido_id} - noturno: "${item.valor_23_as_6}" -> ${valorNoturnoCentavos} centavos`);

        return {
          ...item,
          valor_6_as_23_centavos: valorDiurnoCentavos,
          valor_23_as_6_centavos: valorNoturnoCentavos
        };
      });

      await cadastrarServicosAtendidos(dadosArray);
      console.log('Serviços cadastrados com sucesso!');
      navigate('/pagina-ponto-mototaxi');
    } catch (err) {
      console.error('Erro ao cadastrar serviços:', err);
    }
  };

  return (
    <div className="container py-4">
      <div className="text-center mb-5">
        <FaMotorcycle size={40} className="text-primary mb-2" />
        <h2 className="fw-bold text-primary">Cadastrar Serviços Atendidos</h2>
        <p className="text-muted">Preencha os valores e observações para cada serviço.</p>
      </div>

<form onSubmit={handleSubmit}>
  {listaServicos.map((s) => (
    // vamos mostra o formulário apenas se não for mototaxi, que é em outro lugar.
    s.nome_servico !== 'Moto Taxi' && s.nome_servico !== 'Mototáxi' && s.nome_servico !== 'Encomendas Pequenas' && (
      <div key={s.id} className="card shadow-sm border-0 mb-4">
        <div className="card-header bg-primary text-white fw-bold">
          {s.nome_servico}
        </div>
        <div className="card-body bg-light">
          <p className="text-muted">{s.descricao_servico}</p>

          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">
                <FaSun className="text-warning me-1" /> Valor (06h às 23h)
              </label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control rounded-pill"
                value={formData[s.id]?.valor_6_as_23 || ''}
                onChange={(e) =>
                  handleChange(s.id, 'valor_6_as_23', e.target.value)
                }
                placeholder="0,00"
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                <FaMoon className="text-secondary me-1" /> Valor (23h às 06h)
              </label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control rounded-pill"
                value={formData[s.id]?.valor_23_as_6 || ''}
                onChange={(e) =>
                  handleChange(s.id, 'valor_23_as_6', e.target.value)
                }
                placeholder="0,00"
              />
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">Observação</label>
              <input
                type="text"
                className="form-control rounded-pill"
                value={formData[s.id]?.observacao || ''}
                onChange={(e) =>
                  handleChange(s.id, 'observacao', e.target.value)
                }
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
    )
  ))}

  {listaServicos.length > 0 && (
    <div className="text-center mt-4">
      <button
        type="submit"
        className="btn btn-lg btn-success rounded-pill px-5 shadow"
      >
        <FaDollarSign className="me-2" /> Salvar Serviços
      </button>
    </div>
  )}
</form>



    </div>
  );
}

export default CadastrarServicosAtendidos;
